<template>
  <div class='ml-10'>
    <div class='mb-2 d-flex align-center justify-end'>
      <v-btn text x-small class='ml-3' color='primary' depressed
             @click='refresh'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
        <span class='ml-1'>刷新</span>
      </v-btn>
    </div>
    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      show-header-overflow
      show-overflow
      :height='tableHeight'
      :loading='tableLoading'
      size='small'
      :row-config='{isHover: true}'
      :data='dataList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column field='createBy' title='Member' :filters="[{ data: '' }]" width='200'>
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
      </vxe-column>
      <vxe-column field='nameOfJob' title='Resource Level'
                  :filters="[  {label:'Accenture Leadership',value:'Accenture Leadership'},  {label:'5',value:'5'},{label:'6',value:'6'},{label:'7',value:'7'}
                    ,{label:'8',value:'8'},{label:'9',value:'9'},{label:'10',value:'10'}  ,
                    {label:'11',value:'11'},{label:'12',value:'12'},{label:'13',value:'13'},
                  {label:'Intern',value:'Intern'}]" :filter-multiple='true'
                  width='140'>
      </vxe-column>
      <vxe-column field='likeType' title='Like Type'
                  :filters="[{label:'喜欢', value:'up'}, {label:'不喜欢', value:'down'}]"
                  width='100'>
        <template #default='{ row }'>
          <v-icon v-if="row.likeType === 'up'" size='18'>{{ icons.mdiThumbUpOutline }}</v-icon>
          <v-icon v-else-if="row.likeType === 'down'" size='18'>{{ icons.mdiThumbDownOutline }}
          </v-icon>
        </template>
      </vxe-column>
      <vxe-column field='queryContent' title='Query Content' :filters="[{ data: '' }]" width='240'>
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
      </vxe-column>
      <vxe-column field='answerContent' title='Answer' min-width='230'>
      </vxe-column>
      <vxe-column field='createTime' width='150' title='Create Time' sortable
                  show-header-overflow show-overflow />
    </vxe-table>
    <vxe-pager
      :current-page='pagerOption.pageNum'
      :page-size='pagerOption.pageSize'
      :total='pagerOption.totalData'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />
  </div>
</template>
<script>
import { getAnswerLikePageList } from '../api/index'
import { mdiThumbDownOutline, mdiThumbUpOutline, mdiRefresh } from '@mdi/js'

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [],
      pagerOption: {
        pageNum: 1,
        pageSize: 20,
        totalData: 0,
      },
      icons: {
        mdiThumbDownOutline, mdiThumbUpOutline, mdiRefresh,
      },
      searchParams: {
        nameOfJobList: [],
        createBy: null,
        likeType: null,
        likeTypeList: [],
        queryContent: null,
        answerContent: null,
      },
      tableHeight: 0,
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {
    this.getScreenHeight()
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    refresh() {
      this.pagerOption.pageNum = 1
      this.pagerOption.pageSize = 20
      this.getPageList()
    },
    getScreenHeight() {
      this.tableHeight = window.innerHeight - 64 - 50 - 50
    },
    search(params) {
      const { filters } = params
      console.log('🚀 ~ search ~ filters:', filters)
      this.searchParams.createBy = null
      this.searchParams.nameOfJobList = []
      this.searchParams.likeTypeList = []
      this.searchParams.queryContent = null
      this.searchParams.answerContent = null
      filters.forEach(item => {
        if (item.property === 'nameOfJob') {
          this.searchParams.nameOfJobList = item.values
        } else if (item.property === 'likeType') {
          this.searchParams.likeTypeList = item.values
        } else {
          this.searchParams[item.property] = item.datas[0]
        }
      })
      console.log(this.searchParams)
      this.getPageList()
    },
    changePerPage(currentPage) {
      this.pagerOption.pageNum = currentPage.currentPage
      this.pagerOption.pageSize = currentPage.pageSize
      this.getPageList()
    },
    async getPageList() {
      this.tableLoading = true
      const {
        data: {
          code,
          data,
        },
      } = await getAnswerLikePageList({ ...this.pagerOption, ...this.searchParams })
      if (code === 200) {
        this.dataList = data.records
        this.pagerOption.totalData = data.total
      }
      this.tableLoading = false
    },
  },
}
</script>
